// -----------------------------------以下是针对页面尺码表的交互
(function () {
  function escapeHtml(str) {
    return String(str).replace(/[&<>"']/g, function (m) {
      return {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;'
      }[m];
    });
  }

  function renderPageSizeChart(container) {
    const jsonEl = container.querySelector('[data-page-size-chart-json]');
    const tableEl = container.querySelector('[data-page-size-chart-table]');

    if (!jsonEl || !tableEl) return;

    let data;

    try {
      data = JSON.parse(jsonEl.textContent.trim());

      // 兜底：如果 size_details 被输出成 JSON 字符串，再解析一次
      if (typeof data === 'string') {
        data = JSON.parse(data);
      }
    } catch (e) {
      console.warn('Invalid page size_details JSON', e);
      return;
    }

    const columns = Array.isArray(data.columns) ? data.columns : [];
    const rows = Array.isArray(data.rows) ? data.rows : [];

    const thead = columns.length
      ? `<thead><tr>${
          columns.map(function (c) {
            return `<th scope="col">${escapeHtml(c.label ?? '')}</th>`;
          }).join('')
        }</tr></thead>`
      : '';

    const tbody = rows.length && columns.length
      ? `<tbody>${
          rows.map(function (r) {
            return `<tr>${
              columns.map(function (c) {
                return `<td>${escapeHtml(r?.[c.key] ?? '')}</td>`;
              }).join('')
            }</tr>`;
          }).join('')
        }</tbody>`
      : '';

    tableEl.innerHTML = thead + tbody;
  }

  function initPageSizeCharts() {
    document.querySelectorAll('[data-page-size-chart]').forEach(renderPageSizeChart);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPageSizeCharts);
  } else {
    initPageSizeCharts();
  }

  document.addEventListener('shopify:section:load', function () {
    initPageSizeCharts();
  });
})();

